import styled from "styled-components";

const GenderWrap = styled.div`
  display: flex;
  align-items: center;
  width: 32.5rem;
  font-size: 1.6rem;
  label {
    margin: 0 1rem 0 0;
  }
`;

export default GenderWrap;
